import { render } from "./CustomerManage.vue?vue&type=template&id=7477e68e"
import script from "./CustomerManage.vue?vue&type=script&lang=js"
export * from "./CustomerManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__